"use strict";
// Shared TypeScript types for wearable integrations (Apple Health, Health
// Connect, Polar, y cualquier marca futura). Mirror del enum WearableProvider
// de server/prisma/schema.prisma — mantener sincronizado si se agrega un valor.
Object.defineProperty(exports, "__esModule", { value: true });
